"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var notification_details_popup_component_1 = require("./dialogs/notification-details/notification-details-popup.component");
var notifications_settings_component_1 = require("./settings/notifications-settings.component");
var notification_body_popup_component_1 = require("./dialogs/notification-body/notification-body-popup.component");
var ejustice_notification_service_1 = require("./service/api/ejustice-notification.service");
var NotificationsComponent = /** @class */ (function () {
    function NotificationsComponent(notificationService, dialog, route) {
        this.notificationService = notificationService;
        this.dialog = dialog;
        this.route = route;
        this.destroy$ = new Subject_1.Subject();
        this._pageSize = 10;
        this._totalItemsCount = 0;
        this._currentPage = 0;
        this._hasViewPermission = false;
        this.isNotificationLogsLoaded = false;
        this._dataSource = new material_1.MatTableDataSource([]);
        this._columns = [];
        this.isWithRelatedEntities = false;
        this.isCcVisible = false;
        this.isBccVisible = false;
        this.isDetailsVisible = false;
    }
    NotificationsComponent.prototype.ngOnInit = function () {
        this.initColumnNames();
        var currentTabId = +this.route.snapshot.fragment;
        if (!this.isNotificationLogsLoaded && this.entity && currentTabId === this.tabId) {
            this.initNotificationLogs();
        }
        else {
            this.initActionNotifier();
        }
    };
    NotificationsComponent.prototype.ngAfterViewInit = function () {
        this.dataSource.paginator = this.paginator;
    };
    NotificationsComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    NotificationsComponent.prototype.initActionNotifier = function () {
        var _this = this;
        this.actionNotifier && this.actionNotifier
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (actionNotificationData) {
            if (_this.isActionTabChange(actionNotificationData) && !_this.isNotificationLogsLoaded) {
                _this.initNotificationLogs();
            }
        });
    };
    NotificationsComponent.prototype.isActionTabChange = function (actionNotificationData) {
        return actionNotificationData.key === idm_dynamic_forms_ui_1.ActionNotifierKey.TAB_CHANGE_ACTION && actionNotificationData.data === this.tabId;
    };
    NotificationsComponent.prototype.initColumnNames = function () {
        this._columns = ['subject', 'category', 'notificationSource', 'status', 'date', 'to'];
        if (this.isCcVisible) {
            this._columns.push('cc');
        }
        if (this.isBccVisible) {
            this._columns.push('bcc');
        }
        if (this.isDetailsVisible) {
            this._columns.push('empty');
        }
    };
    NotificationsComponent.prototype.initNotificationLogs = function () {
        var _this = this;
        var paging = new idm_de_core_frontend_1.PagingOptions(this._currentPage, this._pageSize);
        this.notificationService.getNotificationLogs(this.categoryName, this.entity.getInstanceId(), this.isWithRelatedEntities, paging)
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.take(1))
            .subscribe(function (notificationDto) { return _this.notificationLogsHandler(notificationDto); }, function (error) { return _this.notificationLogsErrorHandler(error); });
    };
    NotificationsComponent.prototype.notificationLogsHandler = function (notificationDto) {
        this._dataSource.data = notificationDto.notifications;
        this._totalItemsCount = notificationDto.notificationsCountWithoutPaging;
        this._hasViewPermission = true;
        this.isNotificationLogsLoaded = true;
    };
    NotificationsComponent.prototype.notificationLogsErrorHandler = function (error) {
        this._hasViewPermission = error.status !== 403;
        this._dataSource.data = [];
        this._totalItemsCount = 0;
    };
    NotificationsComponent.prototype.showDetails = function (notification) {
        var deliveryStatuses = notification.deliveryStatuses;
        this.dialog.open(notification_details_popup_component_1.NotificationDetailsPopupComponent, notification_details_popup_component_1.NotificationDetailsPopupComponent.getConfig(deliveryStatuses, notification.to));
    };
    NotificationsComponent.prototype.showBody = function (notification) {
        this.dialog.open(notification_body_popup_component_1.NotificationBodyPopupComponent, notification_body_popup_component_1.NotificationBodyPopupComponent.getConfig(notification.subject, notification.body));
    };
    NotificationsComponent.prototype.search = function (searchModel) {
        var _this = this;
        this._currentPage = 0;
        this.searchModel = searchModel;
        if (this.lastSearchSubscription) {
            this.lastSearchSubscription.unsubscribe();
        }
        var paging = new idm_de_core_frontend_1.PagingOptions(this._currentPage, this._pageSize);
        this.lastSearchSubscription = this.notificationService.search(this.categoryName, this.entity.getInstanceId(), this.isWithRelatedEntities, paging, this.searchModel)
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.take(1))
            .subscribe(function (notificationDto) { return _this.notificationLogsHandler(notificationDto); }, function (error) { return _this.notificationLogsErrorHandler(error); });
    };
    NotificationsComponent.prototype.changeCurrentPage = function (pageEvent) {
        var _this = this;
        this._currentPage = pageEvent.pageIndex;
        if (this.isSearchMode()) {
            var paging = new idm_de_core_frontend_1.PagingOptions(this._currentPage, this._pageSize);
            this.notificationService.search(this.categoryName, this.entity.getInstanceId(), this.isWithRelatedEntities, paging, this.searchModel)
                .pipe(operators_1.takeUntil(this.destroy$), operators_1.take(1))
                .subscribe(function (notificationDto) { return _this.notificationLogsHandler(notificationDto); }, function (error) { return _this.notificationLogsErrorHandler(error); });
        }
        else {
            this.initNotificationLogs();
        }
    };
    NotificationsComponent.prototype.isSearchMode = function () {
        return this.searchModel != null &&
            ((this.searchModel.term && this.searchModel.term.trim() !== '') || this.searchModel.sourceTypeId != null ||
                (this.searchModel.statusIds != null && this.searchModel.statusIds.length !== 0));
    };
    Object.defineProperty(NotificationsComponent.prototype, "hasViewPermission", {
        get: function () {
            return this._hasViewPermission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "totalItemsCount", {
        get: function () {
            return this._totalItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "dataSource", {
        get: function () {
            return this._dataSource;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], NotificationsComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NotificationsComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NotificationsComponent.prototype, "isWithRelatedEntities", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NotificationsComponent.prototype, "isCcVisible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NotificationsComponent.prototype, "isBccVisible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NotificationsComponent.prototype, "isDetailsVisible", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], NotificationsComponent.prototype, "tabId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], NotificationsComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.ViewChild('paginator'),
        __metadata("design:type", material_1.MatPaginator)
    ], NotificationsComponent.prototype, "paginator", void 0);
    NotificationsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-notifications',
            template: require('./notifications.component.html'),
            styles: [require('./notifications.component.css')]
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 12,
            name: 'Notifications',
            groups: [{ 'identity': 'Notification', 'name': 'EJustice Controls' }],
            settings: {
                main: notifications_settings_component_1.NotificationsSettingsComponent,
            },
            template: "<ejustice-notifications [isWithRelatedEntities]=\"'%{isWithRelatedEntities}'\"\n\t\t\t\t\t\t\t  [isCcVisible]=\"%{isCcVisible}\"\n\t\t\t\t\t\t\t  [isBccVisible]=\"%{isBccVisible}\"\n\t\t\t\t\t\t\t  [isDetailsVisible]=\"%{isDetailsVisible}\"\n\t\t\t\t\t\t\t  [tabId]=\"tabId\"\n\t\t\t\t\t\t\t  [actionNotifier]=\"actionNotifier\"\n                          \t  [entity]=\"entity\"\n\t\t\t\t\t\t\t  [categoryName]=\"category\">\n               </ejustice-notifications>"
        }),
        __metadata("design:paramtypes", [ejustice_notification_service_1.EjusticeNotificationService, material_1.MatDialog, router_1.ActivatedRoute])
    ], NotificationsComponent);
    return NotificationsComponent;
}());
exports.NotificationsComponent = NotificationsComponent;
//# sourceMappingURL=notifications.component.js.map